export enum IVolumeTypeDetailsPageTabs {
  Overview = 'overview',
}
